export const HomeNav = [
            {
                icon : "pe-7s-home",
                label: 'Dashboards',
                to: '#/dashboard',
            },
            {
                icon : "pe-7s-users",
                label: 'Leads',
                to : '#/leads',
            },
            {
                icon : "pe-7s-alarm",
                label: 'Activities',
                to : '#/activities',
            },
            {
                icon : "pe-7s-chat",
                label: 'Inbox',
                to: '#/inbox',
            },
            {
                icon : "pe-7s-graph3",
                label: 'Reports',
                to : '#/reports',
            },
];
export const HomeNav2 = [
    {
        icon : "pe-7s-home",
        label: 'Dashboards',
        to: '#/dashboard',
    },
    {

        icon: 'pe-7s-browser',
        label: 'Chatbot',
        to: '#/chatbots',
    },
    /*{
        icon: 'pe-7s-ticket',
        label: 'Tags',
        to : '#/tags',
    },*/

];
export const FormsNav = [
    /*{
        icon: 'pe-7s-diamond',
        label: 'Leads',
        to : '#/leads',
    },
    {
        icon: 'pe-7s-car',
        label: 'Messages',
        to : '#/messages'
    },
    {
        icon: 'pe-7s-display2',
        label: 'Settings',
        to: '#/settings',
    },*/
    {
        icon: 'pe-7s-diamond',
        label: 'Campaigns',
        to : '#/campaigns',
    },
    {
        icon: 'pe-7s-car',
        label: 'Automations',
        to : '#/automations'
    },
    {
        icon: 'pe-7s-display2',
        label: 'Message Templates',
        to: '#/templates',
    },
    {
        icon: 'pe-7s-car',
        label: 'Delivery Logs',
        to: '#/deliverylogs',
    },
    {
        icon: 'pe-7s-display2',
        label: 'Cloud Api',
        to: '#/cloudapi',
    },
    {
        icon: 'pe-7s-speaker',
        label: 'RCS',
        to: '#/rcscampaigns',
    }
];
